import { MakeCall } from './createMakeCall';

export default (makeCall: MakeCall) =>
  (
    methodId: number,
    data: {
      accountNumber: string;
      beneficiaryName: string;
      code: string;
      country: string;
      currency: string;
      homeAddress: string;
      iban: string;
      ownerName: string;
      paypalEmail: string;
      type: 'iban' | 'paypal';
      version: number;
    },
  ) =>
    makeCall<undefined>('PUT', `/api/v2/user/me/payout-method/${methodId}`, {
      data,
    });
